import { render, staticRenderFns } from "./msgs_cards.vue?vue&type=template&id=77693238"
import script from "./msgs_cards.vue?vue&type=script&lang=js"
export * from "./msgs_cards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports